import React from 'react';
import { Loader2 } from 'lucide-react';

const sizes = {
	sm: 'w-4 h-4',
	md: 'w-6 h-6',
	lg: 'w-8 h-8'
};

export default function LoadingSpinner({ size = 'md', fullScreen = false, className = '' }) {
	const spinner = <Loader2 className={`animate-spin text-primary-600 ${sizes[size]} ${className}`} />;
	if (fullScreen) {
		return <div className="w-full h-screen flex items-center justify-center">{spinner}</div>;
	}
	return spinner;
}


